import Layout from "../components/Layout";
import ProjectsMain from "../components/ProjectsMain";

const Projects = () => {
    return (
    <Layout>
        <ProjectsMain/>
    </Layout>
    );
}

export default Projects;
